import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import { Box, Container, Link } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import { useLocation, useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import { jobGrade } from "../../data/jobGradeData";
import Form from "./form";
import api from "../../helper/baseApi";
import { useApiClient } from "../../context/ApiClientContext";
import ErrorAlert from "../../helper/errorAlert";

const Details = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mode, setMode] = useState("view");
  const [dataList, setDataList] = useState([]);
  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const apiUrl = `${mobileApiUrl}jobGrade/details?jobGradeId=${id}`;
      const response = await api.get(apiUrl);

      const jobGradeItem = response.data.data; // single object
      console.log('jobGradeItem', jobGradeItem);

      let jobGrade = "";
      let description = jobGradeItem.name?.trim() || "";

      if (jobGradeItem.name && jobGradeItem.name.includes("-")) {
        const [grade, ...descParts] = jobGradeItem.name.split("-");
        jobGrade = grade.trim().replace(/\s+/g, " "); // collapse multiple spaces
        description = descParts.join(" - ").trim().replace(/\s+/g, " ");
      }

      const formatted = {
        ...jobGradeItem,
        id: jobGradeItem.jobGradeId,
        jobGrade,
        description,
      };

      setDataList([formatted]);
    } catch (error) {
      ErrorAlert(error, navigate);
    }
  };

 useEffect(() => {
  if (location.pathname.includes("edit-job")) {
    setMode("edit");
    fetchData();
  } else if (location.pathname.includes("view-job")) {
    setMode("view");
    fetchData();
  } else {
    setMode("create");
  }
}, [location.pathname]);

  const data = dataList.length > 0 ? dataList[0] : null;

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box display="flex" justifyContent="start" alignItems="center">
            <BasicBreadcrumbs
              first={
                <Link component={RouterLink} to="/job-grade" underline="hover" color="primary.main">
                  Job Grade
                </Link>
              }
              second={
                mode === "view" ? "View" : mode === "edit" ? "Edit" : "Add"
              }
            />

            <Box sx={{ display: "flex" }}></Box>
          </Box>
        </Box>
        <Box px={3} sx={{ width: "100%" }}>
          <Form mode={mode} jobData={data} onModeChange={setMode} />
        </Box>
      </Box>
    </PrivateLayout>
  );
};

export default Details;
